module.exports = __webpack_public_path__ + "img/Apple.538d4814.svg";